import React from 'react'

export const CustomTextarea = ({
  inputRef,
  label,
  value,
  onChange,
  name,
  placeholder,
  error
}: {
  inputRef?: React.RefObject<HTMLTextAreaElement>,
  label: string,
  value: string,
  onChange: any,
  name: string,
  placeholder: string,
  error: string | undefined
}) => {
  const textareaId = `${name}-textarea`
  const errorId = `${name}-error`

  return (
    <div className='custom-input'>
      <label htmlFor={textareaId}>{label}</label>
      <textarea
        ref={inputRef}
        id={textareaId}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        aria-describedby={error ? errorId : undefined}
        aria-invalid={!!error}
      />
      {error && <p className='error' id={errorId}>{error}</p>}
    </div>
  )
}